import { Collection } from '../collection/collection.model';
import {
  QuestionObjective,
  QuestionSubjective,
} from '../question/question.model';
import { QuestionLanguage } from '../subject/subject.model';

export const INITIAL_OBJECTIVE_LABEL = 1;
export const INITIAL_SUBJECTIVE_LABEL = 100;

export enum CollectionItemType {
  Objective = 'objective',
  Subjective = 'subjective',
  Title = 'title',
  Description = 'description',
}

export interface CollectionItem {
  id: number;
  answerPosition: number;
  selectedAnswer: number | null;
  questionPosition: number;
  createdAt: Date;
  updatedAt: Date;
  questionObjective: QuestionObjective;
  questionSubjective: QuestionSubjective;
  collection: Collection;
  collectionItemType: CollectionItemType;
  title: string;
  languages: QuestionLanguage[];
}

export interface CollectionItemModified {
  id: number;
  question: string;
  isObjective: boolean;
  languages: QuestionLanguage[];
  type: CollectionItemType;
  title: string;
  number: number;
  answerPosition: number;
}
